import { render, staticRenderFns } from "./TiposPersonal.view.vue?vue&type=template&id=062dd50c"
import script from "./TiposPersonal.view.vue?vue&type=script&lang=js"
export * from "./TiposPersonal.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports